cockpitApp.filter('sanitizeRouteParam', [
  '$filter',
  function($filter) {
    return function(parameter) {
      return $filter('replaceUmlautCharacters')(parameter).toUpperCase().replace(':', '').trim();
    }
  }
]);
